import GqlOperationError from "../../../internal/revamp/graphql/GqlOperationError";
export default function isGqlOperationError(error) {
    return error instanceof GqlOperationError;
}

//# sourceMappingURL=isGqlOperationError.js.map